import api from "../api/axios";
import { getNativeAccessToken } from "../native/auth";
import { isNativeApp } from "../native/runtime";

const ABS_URL_RE = /^https?:\/\//i;

const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");
const ensureLeadingSlash = (value) =>
  String(value || "").startsWith("/") ? String(value || "") : `/${String(value || "")}`;

export const getApiOrigin = () => {
  const base = String(api?.defaults?.baseURL || "").trim();
  if (ABS_URL_RE.test(base)) {
    try {
      return new URL(base).origin;
    } catch {
      // ignore and fallback
    }
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "";
};

export const buildWsUrl = (path) => {
  const safePath = ensureLeadingSlash(path);
  const base = String(api?.defaults?.baseURL || "").trim();

  if (ABS_URL_RE.test(base)) {
    try {
      const apiUrl = new URL(base);
      const wsProto = apiUrl.protocol === "https:" ? "wss:" : "ws:";
      const wsUrl = new URL(`${wsProto}//${apiUrl.host}${safePath}`);
      const token = isNativeApp() ? getNativeAccessToken() : null;
      if (token) wsUrl.searchParams.set("token", token);
      return wsUrl.toString();
    } catch {
      // ignore and fallback
    }
  }

  if (typeof window !== "undefined") {
    const wsProto = window.location.protocol === "https:" ? "wss:" : "ws:";
    const wsUrl = new URL(`${wsProto}//${window.location.host}${safePath}`);
    const token = isNativeApp() ? getNativeAccessToken() : null;
    if (token) wsUrl.searchParams.set("token", token);
    return wsUrl.toString();
  }

  return safePath;
};

export const toApiAbsoluteUrl = (rawUrl) => {
  const value = String(rawUrl || "").trim();
  if (!value) return null;
  if (ABS_URL_RE.test(value)) return value;
  if (value.startsWith("//")) {
    if (typeof window !== "undefined" && window.location?.protocol) {
      return `${window.location.protocol}${value}`;
    }
    return `https:${value}`;
  }

  const origin = trimTrailingSlash(getApiOrigin());
  const path = ensureLeadingSlash(value);
  if (!origin) return path;
  return `${origin}${path}`;
};
